import ReactGA from 'react-ga4';

// Track page views
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Event tracking functions
export const trackEvent = (
  action: string,
  category = 'User Interaction',
  params: Record<string, any> = {},
) => {
  ReactGA.event({
    category,
    action,
    ...params,
  });
};

// Signup events
export const trackViewSignupChoice = () => {
  trackEvent('view_signup_choice', 'Signup');
};

export const trackClickSignupChoice = (
  choice: 'Porteur de projet' | 'Mécène',
) => {
  trackEvent('click_signup_choice', 'Signup', { choice });
};

export const trackSubmitSignupForm = () => {
  trackEvent('submit_signup_form', 'Signup');
};

export const trackSubmitRnaForm = () => {
  trackEvent('submit_rna_form', 'Signup');
};

export const trackSubmitOrgDetails = () => {
  trackEvent('submit_org_details', 'Signup');
};

export const trackSubmitKeywordSelection = () => {
  trackEvent('submit_keyword_selection', 'Signup');
};

// Mecene discovery events
export const trackViewMecenesSelection = () => {
  trackEvent('view_mecenes_selection', 'Mecene Discovery');
};

export const trackClickMeceneCard = (meceneName: string) => {
  trackEvent('click_mecene_card', 'Mecene Discovery', {
    // eslint-disable-next-line camelcase
    mecene_name: meceneName,
  });
};

export const trackClickMecenePagination = (pageSelected: number) => {
  trackEvent('click_mecene_pagination', 'Mecene Discovery', {
    // eslint-disable-next-line camelcase
    page_selected: pageSelected,
  });
};

// Subscription events
export const trackViewPaywall = () => {
  trackEvent('view_paywall', 'Subscription');
};

export const trackClickPaywallCta = () => {
  trackEvent('click_paywall_cta', 'Subscription');
};
